// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file aggregators/v1/aggregator.proto (package aggregators.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file aggregators/v1/aggregator.proto.
 */
export const file_aggregators_v1_aggregator: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ch9hZ2dyZWdhdG9ycy92MS9hZ2dyZWdhdG9yLnByb3RvEg5hZ2dyZWdhdG9ycy52MSo+CgpBZ2dyZWdhdG9yEhoKFkFHR1JFR0FUT1JfVU5TUEVDSUZJRUQQABIUChBBR0dSRUdBVE9SX0tWSUtLEAFChAEKEmNvbS5hZ2dyZWdhdG9ycy52MUIPQWdncmVnYXRvclByb3RvUAFaBC4vcGKiAgNBWFiqAg5BZ2dyZWdhdG9ycy5WMcoCDkFnZ3JlZ2F0b3JzXFYx4gIaQWdncmVnYXRvcnNcVjFcR1BCTWV0YWRhdGHqAg9BZ2dyZWdhdG9yczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from enum aggregators.v1.Aggregator
 */
export enum Aggregator {
    /**
     * @generated from enum value: AGGREGATOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,

    /**
     * @generated from enum value: AGGREGATOR_KVIKK = 1;
     */
    KVIKK = 1,
}

/**
 * Describes the enum aggregators.v1.Aggregator.
 */
export const AggregatorSchema: GenEnum<Aggregator> = /*@__PURE__*/ enumDesc(file_aggregators_v1_aggregator, 0);
